import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SignUp.module.scss';

function SignInLink({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation() as any;
  return (
    <div className={styles.footerSwitch}>
      {t('alreadyHaveAccount')} <span onClick={onClick}>{t('log_in')}</span>
    </div>
  );
}

export default SignInLink;
